const getDonationGoal = (state) => {
  const { widgets } = state;

  return widgets
    .filter(widget => widget.type === 'DONATION_GOAL')
    .map(widget => widget);
};

const getAllWidgets = (state) => state.widgets;

const getCurrentPage = (state) => state.page;

const isLastDataChunk = (state) => {
  const { lastDataChunk, countPerPage } = state;

  return lastDataChunk.length < countPerPage;
};

export default {
  getDonationGoal,
  getAllWidgets,
  getCurrentPage,
  isLastDataChunk,
};
